var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.75C9.4 17.75 9.31 17.73 9.21 17.69C8.93 17.58 8.75 17.3 8.75 17V11C8.75 10.59 9.09 10.25 9.5 10.25C9.91 10.25 10.25 10.59 10.25 11V15.19L10.97 14.47C11.26 14.18 11.74 14.18 12.03 14.47C12.32 14.76 12.32 15.24 12.03 15.53L10.03 17.53C9.89 17.67 9.69 17.75 9.5 17.75Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49994 17.7495C9.30994 17.7495 9.11994 17.6795 8.96994 17.5295L6.96994 15.5295C6.67994 15.2395 6.67994 14.7595 6.96994 14.4695C7.25994 14.1795 7.73994 14.1795 8.02994 14.4695L10.0299 16.4695C10.3199 16.7595 10.3199 17.2395 10.0299 17.5295C9.87994 17.6795 9.68994 17.7495 9.49994 17.7495Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.75H9.5C4.07 22.75 1.75 20.43 1.75 15V9C1.75 3.57 4.07 1.25 9.5 1.25H14.5C14.91 1.25 15.25 1.59 15.25 2C15.25 2.41 14.91 2.75 14.5 2.75H9.5C4.89 2.75 3.25 4.39 3.25 9V15C3.25 19.61 4.89 21.25 9.5 21.25H15.5C20.11 21.25 21.75 19.61 21.75 15V10C21.75 9.59 22.09 9.25 22.5 9.25C22.91 9.25 23.25 9.59 23.25 10V15C23.25 20.43 20.93 22.75 15.5 22.75Z",
    fill: "#455CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.7505H18.5C15.08 10.7505 13.75 9.42048 13.75 6.00048V2.00048C13.75 1.70048 13.93 1.42048 14.21 1.31048C14.49 1.19048 14.81 1.26048 15.03 1.47048L23.03 9.47048C23.24 9.68048 23.31 10.0105 23.19 10.2905C23.07 10.5705 22.8 10.7505 22.5 10.7505ZM15.25 3.81048V6.00048C15.25 8.58048 15.92 9.25048 18.5 9.25048H20.69L15.25 3.81048Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.93cc9bd6.svg";
export { ForwardRef as ReactComponent };